export const customSymbols = [
  {data: "❤️", category: "Symbols", aliases: ["heart"]},
  {data: "💛", category: "Symbols", aliases: ["yellow_heart"]},
  {data: "💚", category: "Symbols", aliases: ["green_heart"]},
  {data: "💙", category: "Symbols", aliases: ["blue_heart"]},
  {data: "💜", category: "Symbols", aliases: ["purple_heart"]},
  {data: "🖤", category: "Symbols", aliases: ["black_heart"]},
  {data: "💔", category: "Symbols", aliases: ["broken_heart"]},
  {data: "❣️", category: "Symbols", aliases: ["heavy_heart_exclamation"]},
  {data: "💕", category: "Symbols", aliases: ["two_hearts"]},
  {data: "💞", category: "Symbols", aliases: ["revolving_hearts"]},
  {data: "💓", category: "Symbols", aliases: ["heartbeat"]},
  {data: "💗", category: "Symbols", aliases: ["heartpulse"]},
  {data: "💖", category: "Symbols", aliases: ["sparkling_heart"]},
  {data: "💘", category: "Symbols", aliases: ["cupid"]},
  {data: "💝", category: "Symbols", aliases: ["gift_heart"]}
]